<template>
  <WizardFlashMessage>
    <span
      v-if="show"
      class="edu-warning"
    >
      If you are a student or alumnus, <b>please use your work email.</b>
    </span>
  </WizardFlashMessage>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';
import WizardFlashMessage from './WizardFlashMessage.vue';

export default {
  name: 'EduWarningFlashMessage',
  components: { WizardFlashMessage },
  props: {
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState(useWizard, {
      template: (store) => store.flash.template,
    }),
  },
  watch: {
    email(newValue) {
      const templateName = 'edu-warning';

      const show = newValue.endsWith('.edu');
      this.show = show;

      if (show) {
        this.updateFlash({ status: 'warning', template: templateName });
      } else if (this.template === templateName) {
        // Reset if it is current flashMessage
        this.resetFlash();
      }
    },
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash', 'resetFlash']),
  },
};
</script>

<style lang="less" scoped>
.edu-warning {
  font-size: 14px;
}
</style>
